import * as colors from 'scoreboard-colors'

/*
 * Receives a named chart color and returns the color value as a rgba string
 */
export const lookup = color => {
  return `rgba(${lookupObj(color).rgba.join(',')})`
}

/*
 * Receives a named chart color and returns the color object from scoreboard-colors
 */
export const lookupObj = color => {
  return colors.lookup(color)
}

/*
 * Mixes white in with `color`. Returns a rgba string
 */
export const mixWhite = (color, p) => {
  return `rgba(${colors.mix(colors.WHITE, color, p)})`
}

/*
 * Mixes true black in with `color`. Returns a rgba string
 */
export const mixBlack = (color, p) => {
  return `rgba(${colors.mix(colors.BLACK, color, p)})`
}

export const changeColor = colors.changeColor

export const adjustLightness = colors.adjustLightness

export const getTextVariation = colors.getTextVariation
